<c-card *transloco="let t">
    <c-card-body class="px-2">

        <c-row>
          <c-col class="col-lg-6 col-12">
            <h1>{{ t('Map Zones') }}</h1>
          </c-col>
          <c-col class="col-lg-6 col-12 text-end justify-content-end">



            <div class="btn-group mb-2 " role="group">
              <button class="btn btn-info text-white mb-2" type="button"  routerLink="/mgmt/safetyzones/summary">
                <i class="fa-solid fa-map-location-dot"></i>  {{ t('View Map Zone Summary') }}
              </button>
              <button class="btn btn-success text-white mb-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSafetyZone" aria-expanded="false" aria-controls="collapseSafetyZone">
                <i class="fa-solid fa-plus"></i>  {{ t('Create a Map Zone') }}
              </button>
            </div>

          </c-col>
        </c-row>
        <c-row>
          <c-col class="col-12">
            <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('safety_zones_info')">
              <i class="fa-solid fa-circle-info"></i> {{ t('Map Zones can be setup to help see where your workers are working. Once a Map Zone is setup, OK Alone can show how many workers are in each map zone or show the map zone a worker is currently in.') }}
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('safety_zones_info')"></button>
            </div>
            <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('safety_zones_warning')">
              <i class="fa-solid fa-circle-info"></i> {{ t('To get alerts if a worker leaves a zone, please use Safety Zones. These are setup for each individual worker and are found in their profile. ') }}
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('safety_zones_warning')"></button>
            </div>
          </c-col>
        </c-row>

          <c-row class="row-md-6">

            <div class="collapse" id="collapseSafetyZone">
              <div class="card m-3">
                <div class="card-header">
                  <h3>{{ t('Create a New Map Zones') }}</h3>
                </div>
                <div class="card-body">
                <p>{{ t('Enter the name of the map zone you wish to create.') }}</p>
                <form [formGroup]="nameFormGroup" cForm (ngSubmit)="submitForm()">
                  <div class="form-group row mb-2" >
                    <label class="col-sm-4 col-form-label text-end"><svg cIcon name="cilGrain"></svg> {{ t('Map Zone Name') }}</label>
                    <div class="col-sm-8">
                      <input
                        [formControlName]="'name'"
                        cFormControl
                        placeholder="{{ t('Map Zone Name')}}"
                        [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                      />
                      <div *ngIf="submitted && f['name'].errors && f['name'].errors['invalid']" class="invalid-feedback">
                        {{ f['name'].errors['invalid'] }}
                      </div>
                      <div *ngIf="submitted && f['name'].errors && f['name'].errors['required']" class="invalid-feedback">
                        {{ t('A valid name is required') }}
                      </div>
                    </div>
                  </div>

                  <button cButton class="btn btn-primary text-white my-2" type="submit"><i class="fa-solid fa-check"></i> {{ t('Create Map Zone Now') }}</button>

                </form>
              </div>
              </div>
            </div>

          </c-row>

          <c-row>
            <c-col class="col-12 col-lg-6">



                  <form cForm class="row row-cols-lg-auto g-2 align-items-center" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
                    <c-col class="col-sm-6">
                      <label cLabel class="visually-hidden" for="search">
                        {{ t('Search') }}
                      </label>
                      <c-input-group class="me-2 mb-2">
                        <span cInputGroupText><svg cIcon name="cil-search"></svg></span>
                        <input cFormControl id="search" formControlName="search" placeholder="{{ t('Search') }}" />
                      </c-input-group>
                    </c-col>

                    <c-col xs="auto">
                      <button cButton class="btn btn-light me-2 mb-2" type="submit"><i class="fa-solid fa-magnifying-glass"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Search') }}
                        </span>
                      </button>
                      <button cButton class="btn btn-light text-danger mb-2" type="submit" (click)="cancelSearch()" *ngIf="formGroup.value.search" ><i class="fa-solid fa-circle-xmark"></i></button>
                    </c-col>

                    </form>

            </c-col>

            <c-col class="col-12 col-lg-6">

          <c-row class="justify-content-end">
            <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages>1">
              <c-input-group  class="text-end">
                <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                  <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                </select>
              </c-input-group>
            </c-col>
            <c-col xs="auto" class="mb-2">
              <c-input-group>
                <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                  <option value="newest">{{ t('Newest') }}</option>
                  <option value="oldest">{{ t('Oldest') }}</option>
                  <option value="name">{{ t('Name') }}</option>
                </select>
              </c-input-group>
            </c-col>
          </c-row>
        </c-col>
      </c-row>


        <c-row *ngIf="safety_zones">
          <c-col>

            <table
            [hover]="true"
            [responsive]="true"
            [striped]="true"
            align="middle"
            cTable
            class="mb-0 border"
            >
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ t('Name') }}</th>
                  <th scope="col">{{ t('Description') }}</th>
                  <th scope="col"># {{ t('Workers') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let safety_zone of safety_zones">
                  <td>
                    <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/safetyzones/{{safety_zone.id}}">
                      <svg cIcon class="me-2" name="cil-pencil"></svg>
                      {{ t('Edit') }}
                    </button>
                  </td>
                  <td>
                    <b class="fs-5">{{safety_zone.name}}</b>
                  </td>
                  <td>
                    {{safety_zone.description}}
                  </td>
                  <td>
                  {{safety_zone.worker_ids.length}}
                  </td>
                </tr>
              </tbody>
            </table>

          </c-col>
        </c-row>
    </c-card-body>
  </c-card>
